import type { Income } from '@/types/AddIncome'

export const NO_INCOME = 'Income value must be greater than £0'
export const NO_BONUS_INCOME =
  "As a bonus has been declared, it's income value must be greater than £0"
export const NO_AVG_HOURS =
  'Hourly incomes must have an average hours per week greater than 0'
export const MISSING_POSITION = 'Position must not be empty'
export const MISSING_COMPANY_NAME = 'Company name must not be empty'
export const MISSING_PENSION_PROVIDER = 'Pension provider must not be empty'
export const END_DATE_EARLIER_THAN_START_DATE =
  'End date cannot be earlier than the start date'

export function validateIncome(income: Income): [boolean, string[]] {
  const comments: string[] = []

  if (mustHavePositiveIncome(income) && +income.incomeProperties.value <= 0) {
    comments.push(NO_INCOME)
  }

  if (income.hasGuaranteedBonus && +income.bonus.value <= 0) {
    comments.push(NO_BONUS_INCOME)
  }

  if (
    // eslint-disable-next-line eqeqeq
    income.incomeProperties.frequency == 'Hourly' &&
    +income.incomeProperties.averageHoursAWeek <= 0
  ) {
    comments.push(NO_AVG_HOURS)
  }

  // eslint-disable-next-line eqeqeq
  if (income.type == 'regularIncome' && income.status == 'employment') {
    if (!income.position) {
      comments.push(MISSING_POSITION)
    }

    if (!income.company) {
      comments.push(MISSING_COMPANY_NAME)
    }

    // eslint-disable-next-line eqeqeq
    if (income.contractType != 'permanent' && income.endDate < income.startDate) {
      comments.push(END_DATE_EARLIER_THAN_START_DATE)
    }
  }

  if (
    // eslint-disable-next-line eqeqeq
    income.type == 'independentMeans' &&
    // eslint-disable-next-line eqeqeq
    income.meansType == 'pension' &&
    !income.pensionsProvider
  ) {
    comments.push(MISSING_PENSION_PROVIDER)
  }

  // eslint-disable-next-line eqeqeq
  const result = comments.length == 0

  return [result, comments]
}

function mustHavePositiveIncome(income: Income) {
  switch (income.type) {
    case 'thirdParty':
      return false
    default:
      return true
  }
}
